import { Link } from 'react-router'

import './LandingPage.css'

/**
 * Landing publique de sgraphic.art.
 *
 * Page non authentifiee servie a la racine. Volontairement minimaliste
 * (typo-only, tokens DS) pour signaler que le site est en construction
 * sans exposer la surface d'admin. Le seul lien sortant est `/privacy`,
 * requis pour la soumission Pinterest API + RGPD.
 */
export default function LandingPage() {
  return (
    <main className="landing-page">
      <section className="landing-page-card">
        <p className="ui-eyebrow landing-page-eyebrow">SgraphiCCreations</p>
        <h1 className="ui-h1 landing-page-title">sgraphic.art</h1>
        <p className="ui-body landing-page-message">Site en construction.</p>
        <p className="landing-page-tagline">
          Atelier d&rsquo;art independant &mdash; peintures et illustrations originales.
        </p>
      </section>
      <footer className="landing-page-footer">
        <Link to="/privacy" className="landing-page-link">
          Politique de confidentialite
        </Link>
      </footer>
    </main>
  )
}
